import { render, staticRenderFns } from "./ResetSecurityProfileSqaComponent.vue?vue&type=template&id=5f230152&scoped=true"
import script from "./ResetSecurityProfileSqaComponent.vue?vue&type=script&lang=js"
export * from "./ResetSecurityProfileSqaComponent.vue?vue&type=script&lang=js"
import style0 from "./ResetSecurityProfileSqaComponent.vue?vue&type=style&index=0&id=5f230152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f230152",
  null
  
)

export default component.exports